import React from 'react';

const FiltersPanel = ({ genderFilter, onGenderFilter, nameFilter, onNameFilter }) => {
  const filters = [
    { value: 'all', label: 'All' },
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' }
  ];

  return (
    <div className="filters-panel-redesign">
      {/* Name Filter */}
      <div className="filter-section">
        <h3>Search by Name</h3>
        <div className="name-filter">
          <input
            type="text"
            placeholder="Enter name..."
            value={nameFilter}
            onChange={(e) => onNameFilter(e.target.value)}
            className="name-input"
          />
          {nameFilter && (
            <button 
              className="clear-btn"
              onClick={() => onNameFilter('')}
            >
              ×
            </button>
          )}
        </div>
      </div>

      {/* Gender Filter */}
      <div className="filter-section">
        <h3>Filter by Gender</h3>
        <div className="filter-buttons-grid">
          {filters.map(filter => (
            <button
              key={filter.value}
              className={`filter-btn ${genderFilter === filter.value ? 'active' : ''}`}
              onClick={() => onGenderFilter(filter.value)}
            >
              {filter.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FiltersPanel;